import { useMemo } from "react";
import { useOrganizationMessageCompaniesQuery } from "../../generated/graphql";
import { type CompanyOption } from "./message-content";

/** Every company by name, for choosing who a message goes to. */
const useCompanyOptions = () => {
  const { data, loading, error } = useOrganizationMessageCompaniesQuery({
    errorPolicy: "all",
  });
  const companies = useMemo<CompanyOption[]>(
    () =>
      (data?.companies ?? [])
        .map((company) => ({ uuid: company.uuid, name: company.name }))
        .sort((a, b) => a.name.localeCompare(b.name)),
    [data],
  );
  return { companies, loading, error };
};

export default useCompanyOptions;
